import { render, staticRenderFns } from "./RatingsDashboardComponent.vue?vue&type=template&id=1880e8f1&scoped=true&"
import script from "./RatingsDashboardComponent.vue?vue&type=script&lang=js&"
export * from "./RatingsDashboardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880e8f1",
  null
  
)

export default component.exports